/*
 * @Author: wuzhonghai1 wuzhonghai1@jd.com
 * @Date: 2023-12-04 15:09:35
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2026-09-08 17:35:11
 * @FilePath: /isp_International/src/api/newApi/personalCenter/address.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '../../axios';

type AddressApiResponse = Record<string, any>;

/**
 * 获取地址列表
 */
export type GetAddressListType = {
  pageSize: number;
  pageNo: number;
  keywords?: string;
};

const listCache = new Map<string, AddressApiResponse>();
const listInflight = new Map<string, Promise<AddressApiResponse>>();
const detailCache = new Map<string, AddressApiResponse>();
const detailInflight = new Map<string, Promise<AddressApiResponse>>();
let listCacheGeneration = 0;
let detailCacheGeneration = 0;

const buildListCacheKey = (data: GetAddressListType) =>
  JSON.stringify({
    pageNo: data.pageNo,
    pageSize: data.pageSize,
    keywords: data.keywords ?? '',
  });

const invalidateAddressCacheAfterMutation = (res: AddressApiResponse) => {
  if (res?.success) {
    clearAddressCache();
  }
  return res;
};

export function clearAddressListCache() {
  listCacheGeneration += 1;
  listCache.clear();
  listInflight.clear();
}

export function clearAddressDetailCache(addressId?: number | string) {
  detailCacheGeneration += 1;
  if (addressId !== undefined && addressId !== null && addressId !== '') {
    const key = String(addressId);
    detailCache.delete(key);
    detailInflight.delete(key);
    return;
  }
  detailCache.clear();
  detailInflight.clear();
}

export function clearAddressCache(addressId?: number | string) {
  clearAddressListCache();
  clearAddressDetailCache(addressId);
}

/** 全站复用：相同查询参数同一时刻只发起一次 list 请求 */
export const getAddressList = (data: GetAddressListType, forceRefresh = false) => {
  const cacheKey = buildListCacheKey(data);

  if (!forceRefresh && listCache.has(cacheKey)) {
    const cached = listCache.get(cacheKey);
    if (cached) {
      return Promise.resolve(cached);
    }
  }

  if (!forceRefresh && listInflight.has(cacheKey)) {
    const inflight = listInflight.get(cacheKey);
    if (inflight) {
      return inflight;
    }
  }

  const requestGeneration = listCacheGeneration;
  const request = (http('jsonpost', '/jdig/address/list/address', data, false, true) as Promise<AddressApiResponse>)
    .then(res => {
      if (requestGeneration === listCacheGeneration) {
        listCache.set(cacheKey, res);
      }
      return res;
    })
    .finally(() => {
      listInflight.delete(cacheKey);
    });

  listInflight.set(cacheKey, request);
  return request;
};

/**
 * 新增地址
 */
export type CreateAddressRequestType = {
  receiveName: string;
  receivePhone: string;
  country: string;
  countryId: number;
  provinceId: number;
  cityId: number;
  countyId: number;
  detailAddress: string;
  postalCode?: string;
  defaultStatus?: 0 | 1; // 0表示非默认 ，1表示默认
  authScope?: 1 | 2 | 3; // 可见范围：1=仅自己可见, 2=全部可见, 3=部分可见
  selectedPins?: string[]; // 部分可见时选中的账号列表
};
export const createAddress = (data: CreateAddressRequestType) => {
  return (http('jsonpost', '/jdig/address/add', data, true, true) as Promise<AddressApiResponse>).then(
    invalidateAddressCacheAfterMutation,
  );
};

/**
 * 修改地址
 */
export type ModifyAddressRequestType = {
  addressId: number;
  receiveName: string;
  receivePhone: string;
  country: string;
  countryId: number;
  provinceId: number;
  cityId: number;
  countyId: number;
  detailAddress: string;
  postalCode?: string;
  defaultStatus?: 0 | 1; // 0表示非默认 ，1表示默认
  authScope?: 1 | 2 | 3; // 可见范围：1=仅自己可见, 2=全部可见, 3=部分可见
  selectedPins?: string[]; // 部分可见时选中的账号列表
};
export const modifyAddress = (data: ModifyAddressRequestType) => {
  return (http('jsonpost', '/jdig/address/update', data, true, true) as Promise<AddressApiResponse>).then(
    invalidateAddressCacheAfterMutation,
  );
};

/**
 * 保存或更新地址（统一接口）
 */
export type SaveOrUpdateAddressRequestType = {
  addressId?: number | string; // 可选，如果有则是更新，没有则是新增
  receiveName: string;
  receivePhone: string;
  country: string;
  countryId: number;
  provinceId: number;
  cityId: number;
  countyId: number;
  detailAddress: string;
  postalCode?: string;
  defaultStatus?: 0 | 1; // 0表示非默认 ，1表示默认
  authScope?: 1 | 2 | 3; // 可见范围：1=仅自己可见, 2=全部可见, 3=部分可见
  selectedPins?: string[]; // 部分可见时选中的账号列表
};
export const saveOrUpdateAddress = (data: SaveOrUpdateAddressRequestType) => {
  return (http('jsonpost', '/jdig/address/saveOrUpdate', data, true, true) as Promise<AddressApiResponse>).then(
    invalidateAddressCacheAfterMutation,
  );
};

/**
 * 根据ID查询地址详情
 */
// export const getAddressDetail = (id: string) => http('jsonpost', '/jdig/address/add', { id }, true, true);

// 127.0.0.1/address/assign?id=1&pin=hanhongwei测试
// export const
/**
 * 删除地址（单个或批量）
 * @param addressIds 地址ID数组
 */
export const removeAddress = (addressIds: number[]) =>
  (http('jsonpost', '/jdig/address/delete', { addressIds }, true, true) as Promise<AddressApiResponse>).then(
    invalidateAddressCacheAfterMutation,
  );


//获取省市区地址列表
export const getAddressItemList = (params: any) => {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/address/children', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
};

/**
 * 根据ID查询地址详情
 * @param addressId 地址ID
 */
export const getAddressDetail = (addressId: number | string, forceRefresh = false) => {
  const cacheKey = String(addressId);

  if (!forceRefresh && detailCache.has(cacheKey)) {
    const cached = detailCache.get(cacheKey);
    if (cached) {
      return Promise.resolve(cached);
    }
  }

  if (!forceRefresh && detailInflight.has(cacheKey)) {
    const inflight = detailInflight.get(cacheKey);
    if (inflight) {
      return inflight;
    }
  }

  const requestGeneration = detailCacheGeneration;
  const request = (http('get', '/jdig/address/detail', { addressId }, false, true) as Promise<AddressApiResponse>)
    .then(res => {
      if (requestGeneration === detailCacheGeneration) {
        detailCache.set(cacheKey, res);
      }
      return res;
    })
    .finally(() => {
      detailInflight.delete(cacheKey);
    });

  detailInflight.set(cacheKey, request);
  return request;
};

/**
 * 通过邮政编码查询国际地址。scene=location 表示顶部配送位置查询；
 * 新增/编辑收货地址不传 scene，由后端按邮编识别欧洲地址。
 */
export const getPostalCodeAddress = (postalCode: string, scene?: 'location') => {
  const params = scene ? { postalCode, scene } : { postalCode };
  return http('get', '/jdig/address/postalCode/address', params, false, true) as Promise<AddressApiResponse>;
};

/**
 * 保存用户权限
 * @param params { receiverId, type, userPins }
 */
export const saveUserPermission = (params: any) => {
  return http('jsonpost', '/jdig/address/permission/save', params, true, true);
};

/**
 * 获取账号信息分页
 * @param params { receiverId, page, pageSize }
 */
export const getAccountInfoPage = (params: any) => {
  return http('jsonpost', '/jdig/address/permission/account/list', params, true, true);
};

/**
 * 获取已选账号分页
 * @param params { receiverId, page, pageSize }
 */
export const getCheckedAccountPage = (params: any) => {
  return http('jsonpost', '/jdig/address/permission/account/checked', params, true, true);
};

/**
 * 获取地址的 pin 列表
 * @returns pin 数组，如 ["caochuan-V5", "caochuan-V4", "caochuan-V2"]
 */
export const getAddressPins = () => {
  return http('get', '/jdig/address/pins', {}, false, true);
};


// /**
//  * 校验地址权限
//  * @returns boolean true=有权限，false=无权限
//  */
// export const checkAddressAuthority = () => {
//   return http('get', '/jdig/address/authority', {}, false, true);
// };

/**
 * 获取权限配置
 * @returns { address: boolean } true=有操作权限，false=无操作权限（只读）
 */
export const getSettingsAuth = () => {
  return http('get', '/jdig/settings/auth', {}, false, true);
};

/**
 * 设置默认地址
 * @param id 地址ID
 */
export const setDefaultAddress = (id: number | string) => {
  return (http('get', '/jdig/address/setDefault', { id }, true, true) as Promise<AddressApiResponse>).then(
    invalidateAddressCacheAfterMutation,
  );
};
